(function () {
  // Delegated on document, not a specific container: product-info.js re-fetches and swaps the
  // whole PDP buy-button markup on every variant change, so a listener bound to a container
  // element inside that swap would be silently lost on the very first variant switch. document
  // itself never gets replaced, so this survives every swap without needing to be re-attached.
  document.addEventListener('submit', function (e) {
    // Scoped to <product-info> specifically: the same [data-notify-wrap] markup also appears
    // inside the homepage carousel and the catalog card, each with its own local delegated
    // listener already — a plain document-wide match here would double-handle (and double
    // -submit) those, since both listeners would catch the same event.
    var wrap = e.target.closest('product-info [data-notify-wrap]');
    if (!wrap) return;
    var form = e.target.closest('form');
    if (!form) return;
    e.preventDefault();
    submitNotifyForm(form);
  });

  // The error message stays up until the shopper actually does something about it — tapping
  // back into the email field (focusin, which bubbles unlike plain focus) or editing it (input)
  // — rather than silently clearing itself on a timer or lingering forever with no way to
  // dismiss it short of submitting again. Delegated on document for the same reason the submit
  // listener above is: product-info.js swaps the buy-button markup on every variant change.
  document.addEventListener('focusin', function (e) {
    var emailInput = e.target.closest('product-info [data-notify-email]');
    if (emailInput) clearNotifyError(emailInput.closest('[data-notify-wrap]'));
  });
  document.addEventListener('input', function (e) {
    var emailInput = e.target.closest('product-info [data-notify-email]');
    if (emailInput) clearNotifyError(emailInput.closest('[data-notify-wrap]'));
  });

  function clearNotifyError(wrap) {
    if (!wrap) return;
    var errorEl = wrap.querySelector('[data-notify-error]');
    if (errorEl) errorEl.hidden = true;
  }

  // Swaps the button's label for Dawn's own loading-spinner markup (rendered into the button by
  // snippets/product-notify-me.liquid, styled by that same file's [data-notify-submit] rules) —
  // same pattern product-form.js already uses for the add-to-cart button, reused here rather than
  // invented fresh. The label itself stays in the DOM (just hidden via the CSS sibling rule) so
  // there's nothing to restore beyond toggling the spinner back off.
  function setNotifyLoading(submitButton, isLoading) {
    if (!submitButton) return;
    var spinner = submitButton.querySelector('.loading__spinner');
    if (spinner) spinner.classList.toggle('hidden', !isLoading);
  }

  function submitNotifyForm(form) {
    var wrap = form.closest('[data-notify-wrap]');
    var submitButton = form.querySelector('[data-notify-submit]');
    if (submitButton && submitButton.disabled) return;

    if (submitButton) submitButton.disabled = true;
    setNotifyLoading(submitButton, true);
    clearNotifyError(wrap);

    // Sole request now — this form no longer touches Shopify's customer form at all (dropped:
    // duplicated what the Sheet already captures, and its own POST could get silently rejected
    // by hCaptcha off localhost even for a real shopper). back-to-store-module is the one source
    // of truth here; the Shopify customer form is still used, unchanged, by the footer newsletter
    // signup — see snippets/product-notify-me.liquid's top comment.
    fireBackInStockRequest(form, wrap).then(function (ok) {
      if (ok) {
        // Loading state (disabled + spinner) is left ON here on purpose — the form panel is
        // about to cross-fade out under the success panel (see showNotifySuccess), and clearing
        // it first would flash a plain, enabled "email + Notify me" button for that ~400ms
        // transition. showNotifySuccess's own revert timeout clears it once the form panel is
        // actually visible again.
        showNotifySuccess(wrap, form, submitButton);
      } else {
        setNotifyLoading(submitButton, false);
        if (submitButton) submitButton.disabled = false;
        var errorEl = wrap.querySelector('[data-notify-error]');
        if (errorEl) errorEl.hidden = false;
      }
    });
  }

  // Resolves a Promise<boolean> (true once back-to-store-module's Apps Script endpoint returns
  // HTTP ok) — see submitNotifyForm above for how that outcome drives the form's own
  // success/error state. Kept as its own copy rather than shared with product-card.js's
  // identical-shaped function, same reasoning as showNotifySuccess below: the PDP shouldn't
  // depend on that file also being loaded, and the two DOM shapes (variant-selects vs. a card's
  // variants JSON) genuinely differ.
  //
  // Variant id comes from the add-to-cart form's own hidden `.product-variant-id` input — kept
  // in sync by Dawn's own variant-change JS for every product, single-variant or not, so it's a
  // more reliable source here than re-deriving it from `[data-selected-variant]` (which only
  // exists at all for products with more than one variant).
  function fireBackInStockRequest(form, wrap) {
    if (!window.CowalkiesBackInStock || !wrap) return Promise.resolve(false);

    var emailInput = form.querySelector('[name="email"]');
    var email = emailInput ? emailInput.value : '';

    var productFormEl = form.closest('product-form');
    var variantIdInput = productFormEl && productFormEl.querySelector('.product-variant-id');
    var variantId = variantIdInput ? variantIdInput.value : null;

    // variant-selects is NOT nested inside <product-form> — it's a sibling block under
    // <product-info> (see sections/main-product.liquid), so it has to be looked up from there,
    // not from productFormEl like the hidden variant-id input above.
    var options = {};
    var productInfoEl = form.closest('product-info');
    var variantSelects = productInfoEl && productInfoEl.querySelector('variant-selects');
    var selectedScript = variantSelects && variantSelects.querySelector('[data-selected-variant]');
    if (selectedScript) {
      var variantJson = null;
      try {
        variantJson = JSON.parse(selectedScript.textContent);
      } catch (e) {}

      if (variantJson) {
        var names = [];
        try {
          names = JSON.parse((wrap.getAttribute('data-option-names') || '[]'));
        } catch (e) {}
        var values = [variantJson.option1, variantJson.option2, variantJson.option3];
        names.forEach(function (name, i) {
          if (name && values[i] != null) options[name] = values[i];
        });
      }
    }

    return window.CowalkiesBackInStock.notify({ wrap: wrap, email: email, variantId: variantId, options: options });
  }

  // Cross-fades the pre-rendered form/success panels via the wrap's own [data-state] (see
  // snippets/product-notify-me.liquid's CSS) rather than replacing markup — that's what lets the
  // email field come back a few seconds later instead of the success message being a dead end.
  // Kept as its own copy rather than a shared export from product-card.js, same reasoning as
  // that file's own showResult/addToCart split: the PDP shouldn't depend on the card's script
  // also being loaded on whatever page renders <product-info>.
  var NOTIFY_REVERT_MS = 3200;

  function showNotifySuccess(wrap, form, submitButton) {
    if (wrap._notifyRevertTimer) clearTimeout(wrap._notifyRevertTimer);

    var check = wrap.querySelector('[data-notify-check]');
    if (check) {
      check.setAttribute('data-state', 'out');
      void check.offsetWidth;
      check.setAttribute('data-state', 'in');
    }
    wrap.setAttribute('data-state', 'success');

    wrap._notifyRevertTimer = setTimeout(function () {
      wrap.setAttribute('data-state', 'form');
      if (check) check.setAttribute('data-state', 'out');
      var emailInput = form.querySelector('[data-notify-email]');
      if (emailInput) emailInput.value = '';
      setNotifyLoading(submitButton, false);
      if (submitButton) submitButton.disabled = false;
    }, NOTIFY_REVERT_MS);
  }
})();
